export default __webpack_public_path__ + "static/media/home-page-2.60544e09.png";